import type {
  IRecommendation,
  ISiteSignals,
} from '@/components/websiteAnalyzer/recommendationRules';

// V4-only additional recommendations: classic SEO depth + LLM/AI-search (GEO).
// Kept out of the shared engine on purpose so V1's recommendation set is unchanged.
// These are appended to generateRecommendations() inside the V4 component only.
export function extraRecommendations(s: ISiteSignals): IRecommendation[] {
  const recs: IRecommendation[] = [];

  // LLM SEO / Generative Engine Optimization: be quotable by AI answer engines.
  recs.push({
    id: 'llm-seo',
    category: 'seo',
    priority: 52,
    title: 'Get cited by AI search (LLM SEO)',
    finding: s.hasSchema
      ? 'AI answer engines like ChatGPT, Perplexity, and Google AI Overviews now drive real traffic, and they favor pages they can quote cleanly. You already have some structured data, so the next win is concise question-and-answer content they can lift directly.'
      : 'AI answer engines like ChatGPT, Perplexity, and Google AI Overviews now drive real traffic, and they favor pages with structured data plus clear question-and-answer content they can quote. We did not detect structured data on your page, which makes you harder to cite.',
    widgetSlugs: ['faq', 'accordion'],
    freeToolSlugs: ['faq-schema-generator', 'meta-tag-generator'],
    statId: 'ai_overviews_pew',
  });

  // Rich results: structured data that earns SERP features (stars, FAQ accordions).
  recs.push({
    id: 'seo-rich-results',
    category: 'seo',
    priority: 43,
    title: 'Earn rich results in Google with structured data',
    finding: s.hasFaq
      ? 'You have FAQ-style content, but without review or product schema Google cannot turn your listing into a rich result. Adding structured data can earn you star ratings and other eye-catching search features that take up more room and pull more clicks.'
      : 'Structured data (schema) tells Google how to display you, unlocking rich results like star ratings, prices, and breadcrumbs that take up more room in search and earn more clicks.',
    widgetSlugs: ['faq'],
    freeToolSlugs: ['faq-schema-generator', 'og-tag-generator'],
  });

  return recs;
}
